import { render, staticRenderFns } from "./SurveyHeader.vue?vue&type=template&id=37e06ae0&scoped=true"
import script from "./SurveyHeader.vue?vue&type=script&lang=js"
export * from "./SurveyHeader.vue?vue&type=script&lang=js"
import style0 from "./SurveyHeader.vue?vue&type=style&index=0&id=37e06ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e06ae0",
  null
  
)

export default component.exports